import { Capacitor } from "@capacitor/core";
import { Directory, Filesystem } from "@capacitor/filesystem";
import { Share } from "@capacitor/share";
import write_blob from "capacitor-blob-writer";

export async function sharePicture(item: any) {

    //https://firebase.google.com/docs/storage/web/download-files#cors_configuration
    if (Capacitor.isNativePlatform()) {
      const response = await fetch(item.url, { method: "GET", mode: 'cors' });
      const parts = item.path.split("/");
      const name = parts[parts.length - 1];
      var b = await response.blob();

      write_blob({
        path: name,
        directory: Directory.Data,
        blob: b,
        fast_mode: true,
        recursive: true,
        on_fallback(error) {
          console.error(error);
        }
      }).then(function (f) {
        Filesystem.getUri({
          path: name,
          directory: Directory.Data
        }).then(function ({ uri }) {
          Share.share({
            title: 'eGabinet',
            text: '',
            url: uri,
            dialogTitle: '',
          });
        });

      });
    } else {
      window.open(item.url, '_system')
    }

  }

